import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import NotesModal from 'shared/modals/NotesModal';
import { ActivityPopup } from 'shared/forms/NewActivity';
import SendEmailModal from 'shared/modals/SendEmailModal';
import './index.scss';
import { ClippedContent, MessagingIcon, USER_PERMISSIONS } from 'dyl-components';
import { PhoneUtil } from 'utils';
import { TextMessageModal } from 'shared/modals';
import TextIcon from 'shared/TextIcon';
import RestrictedView from 'shared/RestrictedView';


const Account = ({ name, id, linkToAccount, isActionsVisible, account, isModalOutside = false }) => {
    const [openForm, setOpenForm] = useState(false);
    const onCloseForm = () => {
        setOpenForm('');
    }

    const dispatch = useDispatch();

    const { emailIntegrations, officeViewCreds } = useSelector((state) => {
        return {
            officeViewCreds: state.officeView.creds,
            emailIntegrations: state.oauth_integrations.integrations,
        };
    });
    const isPhoneSystemSupported =
        PhoneUtil.isPhoneSystemSupported(officeViewCreds);
    const phone = account?.phone?.phone || account?.phone;
    const canEmail = Boolean(account.email?.id);
    const hasEmailIntegrations = emailIntegrations.length > 0;    

    const getModal = () => {
        switch (openForm) {
            case "email":
                return <SendEmailModal
                    open
                    onClose={onCloseForm}
                    account_id={account?.id}
                    isAccountModal={true}
                    account={account}
                />;
            case "note":
                return <NotesModal
                    open
                    onClose={onCloseForm}
                    account={account}
                />;
            case "text":
                return <TextMessageModal
                    open
                    onClose={onCloseForm}
                    contact_id={account.id}
                    contact_name={`${account.name}`}
                    isAccount
                />;    
            default:
                <React.Fragment />
        }
    }

    const onClickToDial = () => {
        PhoneUtil.C2D({ payload: { account_id: account.id, destination: phone }, dispatch });
    }

    return (
        <>
            <div className='AccountComponent'>
                {name && <Avatar name={name} maxInitials={2} round size='3em' />}
                <div className="AccountComponent__information">
                    <span className='AccountComponent__Link'>
                        <ClippedContent>{linkToAccount}</ClippedContent>
                        <span className="AccountComponent__Subtitle">{id && `ID: ${id}`}</span>
                    </span>
                    {isActionsVisible ? (
                        <div className='AccountComponent__Actions'>
                            {isPhoneSystemSupported ? (
                                <Icon
                                    className="fa-solid fa-phone"
                                    onClick={onClickToDial}
                                    disabled={!phone}
                                    link
                                />
                            ) : (
                                <ActivityPopup
                                    trigger={
                                        <Icon
                                            className="fa-solid fa-phone"
                                            link
                                        />
                                    }
                                    activityProps={{
                                        hideActivitySelection: true,
                                        account: {
                                            id: account?.id,
                                        }
                                    }}
                                    open={openForm === 'call-activity'}
                                    onOpen={() => setOpenForm('call-activity')}
                                    onClose={onCloseForm}
                                />
                            )}
                            <TextIcon 
                                onOpenActivityForm={() => setOpenForm('text-activity')}
                                account_id={account?.id}
                                isActivityFormOpen={openForm === 'text-activity'}
                                onCloseActivityForm={onCloseForm}
                                onOpenTextModal={() => setOpenForm('text')}
                                phone={phone}
                            />
                            {canEmail ?
                                hasEmailIntegrations ? <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.ACCOUNT_ADD}><Icon className='fa-solid fa-envelope' link onClick={async () => {
                                    setOpenForm("email");
                                }} /></RestrictedView> :
                                    <ActivityPopup
                                        trigger={
                                            <span style={{ marginRight: 10 }}>
                                                <MessagingIcon size='' icon={'mail'} onClick={() => {
                                                    setOpenForm("email-activity")
                                                }} />
                                            </span>
                                        }
                                        activityProps={{
                                            readTimeline: () => { },
                                            emailOnly: true,
                                            account: account
                                        }}
                                        open={openForm === 'email-activity'}
                                        onOpen={() => setOpenForm('email-activity')}
                                        onClose={onCloseForm}
                                    />
                                : <Icon className='fa-solid fa-envelope' link disabled />
                            }
                            <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.ACCOUNT_ADD}>
                                <Icon className='fa-sharp fa-solid fa-pen-clip' link onClick={() => setOpenForm('note')} />
                            </RestrictedView>
                        </div>
                    ) : (
                        <div className='AccountComponent__MasterAccountActions'>
                            <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.MASTER_ACCOUNT_ADD}>
                                <Icon className='fa-sharp fa-solid fa-pen-clip' link onClick={() => setOpenForm('note')} />
                            </RestrictedView>
                        </div>
                    )}
                </div>
            </div>
            {!isModalOutside && getModal()}
        </>
    );
}

export default Account;
